import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MyResourcesComponent } from './my-resources/my-resources.component';
import { PlatformsLandingPageComponent } from './Applications/platforms/platforms-landing-page.component';
import { authGuard } from './ai-search/auth.guard';

//ng g m Applications/Web --route w --module app.module
//ng g m Applications --routing

const appRoutes: Routes = [
    // NOTE: the WebModule route below is an empty-path (path: '') lazy route, which
    // ALWAYS matches (it consumes zero segments) and its own routing table now ends
    // with a catch-all `{ path: ':areaName' }` SEO landing route + `**` redirect.
    // That means whatever child route is listed first and matches wins - so every
    // feature area with its own path prefix (admin, profile, m, platforms,
    // myresources) MUST be declared BEFORE the empty-path WebModule route, otherwise
    // e.g. /admin is swallowed by WebModule's `:areaName` route and renders the area
    // landing page instead of the admin login.
    { path: 'm', loadChildren: () => import('./Applications/mobile/mobile.module').then(m => m.MobileModule) },
    { path: 'admin', loadChildren: () => import('./Applications/admin/admin.module').then(m => m.AdminModule) },
    { path: 'profile', loadChildren: () => import('./Applications/profile/profile.module').then(m => m.ProfileModule) },
    { path: 'platforms', component: PlatformsLandingPageComponent },
    { path: 'myresources', component: MyResourcesComponent },
    // AI search landing page is the default route; the classic home stays at /home.
    { path: '', pathMatch: 'full', loadComponent: () => import('./ai-search/home/home.component').then(m => m.HomeComponent) },
    { path: 'signin', loadComponent: () => import('./ai-search/login/login.component').then(m => m.LoginComponent) },
    {
        path: 'search-results',
        canActivate: [authGuard],
        loadComponent: () => import('./ai-search/search-results/search-results.component').then(m => m.SearchResultsComponent)
    },
    // Remaining '' paths fall through to WebModule. Keep this LAST (before the
    // wildcard) for the reason described above.
    { path: '', loadChildren: () => import('./Applications/web/web.module').then(m => m.WebModule) },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }